import { Globe } from 'lucide-react';

import { cn } from '@sshop/ui';
import type { LocaleCode } from '@sshop/domain';

import { languageSwitcherStyles as s } from './LanguageSwitcher.styles';
import type { LanguageSwitcherProps } from './LanguageSwitcher.types';
import { useSwitchLanguage } from './useSwitchLanguage';

const LABEL: Record<LocaleCode, string> = {
  ge: 'ქარ',
  en: 'EN',
};

/**
 * Animated single-language toggle. Shows only the current language; click swaps
 * to the other and navigates while preserving path/search/hash.
 */
export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { current, next, switchTo } = useSwitchLanguage();

  return (
    <button
      type="button"
      className={cn(s.root, className)}
      onClick={switchTo}
      aria-label={`Switch language to ${LABEL[next]}`}
      title={LABEL[next]}
    >
      <Globe className={s.icon} aria-hidden />
      <span className={s.labelWrap}>
        <span key={current} className={s.label}>
          {LABEL[current]}
        </span>
      </span>
    </button>
  );
}
